//设备基础信息维护
import axiosInstanceMethods from "../../config/request";
const apiHitIotBase = {
  //get
};
export default apiHitIotBase;
